import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { HomeRoutingModule } from './home-routing.module';
import { HomePageComponent } from './pages/home-page/home-page.component';
import { SharedModule } from '../../shared/shared.module';
import { AuctionsModule } from '../auctions/auctions.module';
import { ProfilesModule } from '../profiles/profiles.module';
import { VbHomeBannerComponent, VbSpinnerComponent } from '@viewbid/ui';

@NgModule({
    declarations: [HomePageComponent],
    imports: [
        CommonModule,
        HomeRoutingModule,
        ReactiveFormsModule,
        SharedModule,
        AuctionsModule,
        ProfilesModule,
        VbHomeBannerComponent,
        VbSpinnerComponent,
    ],
})
export class HomeModule {}
